import styled from "styled-components";
import { COLORS, responsive } from "../../../../../../styles/constants.style";
import {
  fontWeightBold,
  h3Regular,
} from "../../../../../../components/typography/MuiTypography.style";

export const ViewActivityWrapper = styled.div`
  .MuiTabs-flexContainer {
    border-bottom: 5px solid ${COLORS.cirrus_black3};
  }

  .checkbox-container {
    .MuiButtonBase-root {
      margin-right: 16px;
    }
  }

  .cell-country {
    width: 40%;
  }

  .cell-measurement {
    min-width: 200px;
  }

  .MuiGrid2-root {
    padding-right: 18px;
    margin-top: 40px;

    &:nth-child(-n + 3) {
      margin-top: 0px;
    }
    ${responsive.TABLET_PORTRAIT`
      &:nth-child(1), &:nth-child(2) {
        margin-top: 0px;
      }
      &:nth-child(n+3) {
        margin-top: 40px;
      }
    `}
    ${responsive.MOBILE`
      &:nth-child(1) {
        margin-top: 0px;
      }
      &:nth-child(n+2) {
        margin-top: 16px;
        }
    `}
  }

  .MuiGrid2-container {
    padding-right: 0px;
  }

  .activity-tab-general {
    padding: 24px 0px 24px 16px;
    ${responsive.MOBILE`
      padding: 0 0 16px 16px; 
    `}
  }

  .select-applicable {
    color: ${COLORS.cirrus_black10};
    border-top: 1px dotted ${COLORS.primary_light_blue4};
    margin-top: 24px;
    padding: 24px 16px 0px;
    ${responsive.MOBILE`
      margin-top: 0;
      padding: 16px 16px 0;
    `}
  }

  .default-activity-value {
    ${responsive.MOBILE`
      padding-bottom: 16px;
    `}
  }

  .checkbox-container {
    display: flex;
    padding: 24px 16px;
    ${responsive.MOBILE`
      padding: 8px 16px;
    `}
  }

  .view-locale-link {
    ${h3Regular}
    ${fontWeightBold}
    text-decoration: underline;
    color: ${COLORS.primary_light_blue};
  }

  .topic-value {
    max-width: 200px;
  }
`;
